import { useQuery } from '@tanstack/react-query';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import { fetchGoals, fetchMetrikaFilters, updateGoal } from './api';
import { MetrikaSelectCell } from './MetrikaSelectCell';

const QUERY_KEY = 'metrika-goals';

export const MetrikaSetupTab = () => {
  const filters = useQuery({ queryKey: ['metrika-filters'], queryFn: fetchMetrikaFilters });
  const goals = useQuery({ queryKey: [QUERY_KEY], queryFn: fetchGoals });

  return (
    <div className="box">
      <div className="box-body">
        <QueryStatus
          isLoading={goals.isLoading}
          error={goals.error}
          errorText="Ошибка загрузки целей"
        />
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название цели</th>
              <th>Описание цели</th>
              <th>Номер цели</th>
              <th>Параметр</th>
            </tr>
          </thead>
          <tbody>
            {goals.data?.map((goal) => (
              <tr key={goal.id}>
                <td>{goal.id}</td>
                <td>{goal.name}</td>
                <td>{goal.type}</td>
                <td>{goal.goals_id}</td>
                <td>
                  <MetrikaSelectCell
                    value={String(goal.local_type ?? '')}
                    options={filters.data?.goalsTypes ?? []}
                    placeholder="параметр"
                    queryKey={QUERY_KEY}
                    save={(localType) => updateGoal(goal.goals_id, localType)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
